export default "__VITE_ASSET__Bai4jlLi__"